import { PaginationModel, Product } from '@spartacus/core';
import { StatusRequest } from '../../../../core/models/request-status.model';
import { Option } from '../../../../core/models/option.model';

export enum SEARCH_TYPE {
  BASIC = 'BASIC',
  ADVANCED = 'ADVANCED',
}

export const searchtypes: string[] = Object.keys(SEARCH_TYPE)
  .filter(key => isNaN(Number(key)))
  .map(key => SEARCH_TYPE[key as keyof typeof SEARCH_TYPE]);

export interface QuotesProductListSearch extends StatusRequest {
  products?: Product[];
  pagination?: PaginationModel;
}

export interface ItemEntry {
  code: string;
  qty?: number;
  frequency?: string;
  reqPrice?: string;
  product?: Product;
}

export interface FrequencyRequest extends StatusRequest {
  frequencies?: Option[];
}
